import React, {useState,useEffect,useRef,useMemo, useCallback} from 'react';

import PrintCommon from './PrintCommon';
import {wordwrap} from './Commons';

import { useSelector,useDispatch } from 'react-redux';
import { fetchAllBook, acceptOrderCall, declineOrder, fetchAllOrderStatus } from '../Redux/AllBook/AllBookActions';
import { restShut, restShutUpdate } from '../Redux/RestShut/RestShutActions';
import { deliveryShut, deliveryShutUpdate } from '../Redux/DeliveryShut/DeliveryShutActions';
import { useHistory } from 'react-router-dom';
import DatePicker from "react-datepicker";
import toast from 'react-hot-toast';
import moment from 'moment';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";


function Orders() {

  const [restOnOff,setRestOnOff] = useState(false)
  const [deliveryOnOff,setDeliveryOnOff] = useState(false)
  const allBookData = useSelector(state =>state.AllBook)
  const restStateData = useSelector(state =>state.RestShutStatus)
  const deliveryStateData = useSelector(state =>state.DeliveryShutStatus)
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error,setError] = useState(null)
  // store data access End
  const dispatch = useDispatch()  // for accessing the redux function
  const history = useHistory();
  const [allBookResult,setBookResult] = useState([])

  const [currentorderTab,setCurrentorderTab] = useState(32)
  const [pageNumber, setPageNumber] = useState(0)
  const [singleOrder, setSingleOrder] = useState([])
  const listInnerRef = useRef();
  const [tabValue,setTabValue] = useState(2)
  const [responseMessage, setResponseMessage] = useState('')
  const [orderDetailResult, setOrderResult] = useState('')
  const [show,setShow] = useState(true);
  const [open, setOpen] = useState(true);
  const [customMinute, setCustomMinute] = useState('');

  // Define the handleCustomMinuteChange callback function
  const handleCustomMinuteChange = useCallback((event) => {
  // Get the value of the input field
  const value = event.target.value;
  // Set the customMinute state with the value
  setCustomMinute(value);
  setOrderTime(value)
  if (value.length > 2) {
    // Return false
    alert("Only added two digits not more than two");
    }
  }, []);
  
  
  const ordertime = localStorage.getItem("ordertime");
  const ordertimeArray = ordertime.split('|');
  const orderunit = localStorage.getItem("orderunit");
  const renderOrdertime = (value, index) => {
    // Return a label element with a radio button and a text
    return (
      <>
    <label htmlFor={value} className="lableforaddon" key={index}>
    <input
    type="radio"
    id={value}
    name="ordertime"
    value={value}
    style={{marginRight:"10px"}}
    onChange={(event) => setOrderTime(event.target.value)}
    />
   {value === "-1" ? "Custom" : value}
    <span style={{marginLeft:"5px", color:"black"}}>{orderunit}</span>
    </label>
    {value === "-1" && (
      <input
      type="number"
      id="custom-minute"
      name="custom-minute"
      value={customMinute}
      onChange={handleCustomMinuteChange}
      />
      )}
     <br />
     <hr />
     </>
    );
    }
  
  const ordertimeElements = ordertimeArray.map(renderOrdertime);
  

// fetch allBook  api hook start
useEffect(() =>{
  setCurrentorderTab(32);
  dispatch(fetchAllOrderStatus());
  dispatch(fetchAllBook(0, false, {filter:32}))
  dispatch(restShut())
  dispatch(deliveryShut())
},[dispatch])
// fetch allBook api hook End



// add data of allFees api into constant,hook start
useMemo(() =>{
  if(allBookData && allBookData.all_book && allBookData.all_book && !allBookData.all_book_loading){
    setError('');
    if(allBookData.is_added){
      allBookData.all_book.forEach((item) => {
        if(allBookResult.indexOf(item) == -1){
          setBookResult(allBookResult.concat(allBookData.all_book));
        }
      });
    } else if(!allBookData.is_added) {
      setBookResult(allBookData.all_book)
    }
  }
},[allBookData])
// add data of allFees api into constant,hook End
const [orderTime, setOrderTime] = useState('');
const [saveOrder,setSaveOrder] = useState(false);
const [orderId, setOrderId] = useState('');

const openTimingModal = (order_id, status, e) => {
    setOrderId(order_id);
    const modal = new window.bootstrap.Modal(document.getElementById("exampleModal"));
    modal.show();
  };


const handleacceptOrder = (order_id, status, e) => {
  try {
    let filtr = {filter:e};
    if(startDate && endDate) {
      if(startDate > endDate || startDate > new Date() || endDate > new Date()) setError('invalid Date')
      else if((endDate - startDate) / (1000 * 3600 * 24) > 31) setError('Orders can not be more than 31 days!')
      else {
       filtr = {
         dateFilter: {
           startDate: moment(startDate).format('DD-MM-YYYY'),
           endDate: moment(endDate).format('DD-MM-YYYY'),
         },
         filter: e
       };
      }
    }
    // setOrderId(order_id);
    // setOrderTime('');
    //setShow(true);
    if (orderTime.length > 0 && status == 'confirm') {
       dispatch(acceptOrderCall(order_id, orderTime, status, filtr));
      //  setOpen(false);
      //  setOrderId(order_id);
       setSaveOrder(true);
    } else if (orderTime.length == 0 && status == 'confirm') {
       setShow(false);
       throw new Error("Please select a time for the order");
    } else if (status == 'cancel') {
       dispatch(acceptOrderCall(order_id, "", status, filtr));
    } else if (status == 'ready_for_pickup') {
       dispatch(acceptOrderCall(order_id, "", status, filtr));
    } else if (status == 'picked_up') {
       dispatch(acceptOrderCall(order_id, "", status, filtr));
    } else if (status == 'delivered') {
       dispatch(acceptOrderCall(order_id, "", status, filtr));
    } else {
       setShow(false);
       throw new Error("Please select a time for the order");
    }
  } catch (error) {
    toast(error.message);
  }
};

useMemo(() =>{
  if(allBookData && allBookData.single_order_update){    
   
      if(allBookData.single_order_update.order_status == 'Complete') {
        setShow(true);
        setError('');
        orderDetailResult=null;
        setResponseMessage("Order Delivered!");
       
      } else if(allBookData.single_order_update.order_status != 'Complete' && !allBookData.single_order_update.order_status.toLowerCase().startsWith("cancel")) {
        setShow(true);
        setError('');
        
        setResponseMessage(`Order ${allBookData.single_order_update.order_status.toLowerCase().replaceAll('_', ' ')}!`);
        
      } else if(allBookData.single_order_update.order_status.toLowerCase().startsWith("cancel")) {
        setShow(true);
        setError('');
        setResponseMessage("Order Cancelled!");
        orderDetailResult=null;
      }

  }
},[allBookData])

// add data of allFees api into constant,hook start
useMemo(() =>{
  if(restStateData && restStateData.rest_shut && restStateData.rest_shut.status){
    setRestOnOff(restStateData.rest_shut.status)
  }
},[restStateData])
// add data of allFees api into constant,hook End

// add data of allFees api into constant,hook start
useMemo(() =>{
  if(deliveryStateData && deliveryStateData.delivery_shut && deliveryStateData.delivery_shut.status){
    setDeliveryOnOff(deliveryStateData.delivery_shut.status)
  }
},[deliveryStateData])
// add data of allFees api into constant,hook End

const onScroll = () => {
  if (listInnerRef.current) {
    const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
   
    if (Math.ceil(scrollTop + clientHeight) == scrollHeight) {
     
      if(startDate && endDate){
        dispatch(fetchAllBook(pageNumber+1, true, {
           dateFilter: {
             startDate: moment(startDate).format('DD-MM-YYYY'),
             endDate: moment(endDate).format('DD-MM-YYYY'),
           },
           filter: currentorderTab
        }))
      } else {
        dispatch(fetchAllBook(pageNumber+1, true, {
          filter: currentorderTab
        }))
      }
      setPageNumber(pageNumber+1);
      // This will be triggered after hitting the last element.
      // API call should be made here while implementing pagination.
    }
  }
};

const handleDateChange = (value) =>{
  const selectedData = moment(value).format('DD-MM-YYYY');

 //setInputValues({...inputValues,from_date:selectedData})
 setStartDate(value)
}

const handleEndDateChange = (value) =>{

  const selectedData = moment(value).format('DD-MM-YYYY');

 //setInputValues({...inputValues,to_date:selectedData})
 setEndDate(value)

}


const handlefilterSelect = (e) => {
  setPageNumber(0);
  setTabValue(e);
  if(e === 'all') {
    setCurrentorderTab(0);
  }
  else {
    setCurrentorderTab(e);
  }
  dispatch(fetchAllOrderStatus());
  if(startDate && endDate) {
    if(startDate > endDate || startDate > new Date() || endDate > new Date()) setError('invalid Date')
    else if((endDate - startDate) / (1000 * 3600 * 24) > 31) setError('Orders can not be more than 31 days!')
    else dispatch(fetchAllBook(0, false, {
      dateFilter: {
        startDate: moment(startDate).format('DD-MM-YYYY'),
        endDate: moment(endDate).format('DD-MM-YYYY'),
      },
      filter: e
    }))
  } else {
     dispatch(fetchAllBook(0, false, {filter:e}))
  }
}

const handleOrderSelect = (orderNo) => {
  history.push({
    pathname: "/order_detail",
    state: {order: orderNo, isNotify: false}
  })
}


const setrestStatus = (event) =>{
  setRestOnOff(!restOnOff)
    dispatch(restShutUpdate(!restOnOff))
}

const setdeliveryStatus = (event) =>{
  setDeliveryOnOff(!deliveryOnOff)
    dispatch(deliveryShutUpdate(!deliveryOnOff))
}

// const handleacceptOrder = (order_id) =>{
//   dispatch(acceptOrder(order_id))
// }

const filterOrders = () =>{
  setPageNumber(0);
  if(startDate && endDate){
   if(startDate > endDate || startDate > new Date() || endDate > new Date()) setError('invalid Date')
   else if((endDate - startDate) / (1000 * 3600 * 24) > 31) setError('Orders can not be more than 31 days!')
   else dispatch(fetchAllBook(0, false, {
      dateFilter: {
        startDate: moment(startDate).format('DD-MM-YYYY'),
        endDate: moment(endDate).format('DD-MM-YYYY'),
      },
      filter: currentorderTab
    }))
  }
}

const clearOrders = () =>{
  setStartDate();
  setEndDate();
  dispatch(fetchAllBook(0, false, {filter:currentorderTab}))
}

const handledeclineOrder = (order_id) =>{
dispatch(declineOrder(order_id))
}

        return (
<>
          <div className="dashboard-content-one">

        {/* Dashboard Content Start Here */}
      <div className="row gutters-20">
        <div className="col-12 col-xl-12 col-12-xxxl">
          <div className="card dashboard-card-one pd-b-20">
            <div className="card-body">
              <div className="heading-layout1">
                <div className="item-title">
                <h3>{singleOrder && singleOrder.length > 0 ? 'Order Details' : 'All Orders'}</h3>
                </div>
                <div className="dropdown">
                  <a className="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false"></a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a className="dropdown-item" href="#"><i className="fas fa-times text-orange-red" />Close</a>
                    <a className="dropdown-item" href="#"><i className="fas fa-cogs text-dark-pastel-green" />Edit</a>
                    <a className="dropdown-item" href="#"><i className="fas fa-redo-alt text-orange-peel" />Refresh</a>
                  </div>
                </div>
              </div>

              {allBookData.all_book_error ? (<span style={{color:'red'}}>{allBookData.all_book_error.error}</span>): (<></>)}
              {error ? (<span style={{color:'red'}}>{error}</span>): (<></>)}

              <div className="row">
                    <div className="col-3-xxxl col-lg-4 col-12 form-group">
                         <label>Start Date</label>
                        <DatePicker selected={startDate} className="form-control" onChange={(date) => handleDateChange(date)} />
                          {error != null && error.from_date ? (<h6 className="addStudent-error">*{JSON.stringify(error.from_date).replace(/[\[\]"]+/g,"")}</h6>):null}
                    </div>
                    <div className="col-3-xxxl col-lg-4 col-12 form-group">
                          <label>End Date</label>
                        <DatePicker selected={endDate} className="form-control" onChange={(date) => handleEndDateChange(date)} />
                          {error != null && error.to_date ? (<h6 className="addStudent-error">*{JSON.stringify(error.to_date).replace(/[\[\]"]+/g,"")}</h6>):null}
                    </div>
                    <div className="col-6-xxxl col-lg-4 col-12 form-group mg-t-35">
                       <button type="button" className="btn-fill-lg bg-blue-dark btn-hover-yellow" onClick={(e) =>filterOrders()}>Apply Filter</button>             
                       <button type="reset" className="btn-fill-lg bg-blue-dark btn-hover-yellow mg-l-10" onClick={(e) =>clearOrders()}>Clear</button>
                    </div>
               </div>

              <div className="earning-report1">
              
                  <div className="card">
                      <div className="card-body">

                        <div className="table-box-wrap">

                            <div className="row gutters-8">


                              <div className="col-lg-12 form-group filterbtn">
                                <button type="submit" onClick={e=>handlefilterSelect(32)} className={currentorderTab === 32 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>All</button>
                                <button type="submit" onClick={e=>handlefilterSelect(2)} className={currentorderTab === 2 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>New</button>
                                <button type="submit" onClick={e=>handlefilterSelect(16)} className={currentorderTab === 16 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Confirmed</button>
                                <button type="submit" onClick={e=>handlefilterSelect(14)} className={currentorderTab === 14 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Ready</button>
                                <button type="submit" onClick={e=>handlefilterSelect(12)} className={currentorderTab === 12 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Delivered</button>
                                <button type="submit" onClick={e=>handlefilterSelect(4)} className={currentorderTab === 4 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Completed</button>
                                <button type="submit" onClick={e=>handlefilterSelect(5)} className={currentorderTab === 5 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Cancelled</button>
                                <button type="submit" onClick={e=>handlefilterSelect(18)} className={currentorderTab === 18 ? "btn btn-outline-primary active" : "btn btn-outline-primary"}>Future Order</button>
                              </div>
                              {/* <div className="col-lg-2 form-group">

                              </div> */}
                            </div>

{allBookData.single_order_update && responseMessage && show ? 
          <p className="alert alert-success w-auto" role="alert">
            {responseMessage}
          </p> : <p></p>
         }

         {allBookData.single_order_update && error ? 
          <p className="alert alert-danger w-auto" role="alert">
            {error}
          </p> : <p></p>
         }
                          {allBookData && allBookData.all_book_loading === true ?
                          (
                          <div style={{marginLeft:'40%'}}>
                            <Loader
                              className = "student-detail-loader"
                              type="ThreeDots"
                              color="#fea801"
                              height={80}
                              width={150}

                            /></div>
                          ) : <></>}
                        <div className="table-responsive expenses-table-box">
                       <div onScroll={onScroll} ref={listInnerRef} className="table-height">

                          <table className="table data-table text-nowrap">
                              <thead>
                                <tr>
                                  <th>
                                    Order ID
                                  </th>
                                  <th>Order Total</th>
                                  <th>Order Status</th>
                                  <th>Name</th>
                                  <th>E-Mail</th>
                                  <th>Order Date</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                              {allBookResult && allBookResult.length > 0 && allBookResult.map((item,index)=>{
                                return (
                                  <tr>
                                    <td>
                                    <a className="orderclick" onClick={e=>handleOrderSelect(item.order_id)}>{item.order_id}</a>
                                    </td>

                                    <td>${item.order_total ? item.order_total : ''}</td>
                                    {item.order_status === 'Processing' ? <td className="badge badge-pill badge-primary d-block mg-t-8">New</td> : null}
                                    {item.order_status === 'ORDER_AHEAD' ? <td className="badge badge-pill badge-primary d-block mg-t-8 futureorder">Order Ahead</td> : null}
                                    {item.order_status === 'Confirmed' ? <td className="badge badge-pill badge-secondary d-block mg-t-8">Confirmed</td> : null}
                                    {item.order_status === 'Complete' ? <td className="badge badge-pill badge-dark d-block mg-t-8">Completed</td> : null}
                                    {item.order_status === 'Cancelled' ? <td className="badge badge-pill badge-danger d-block mg-t-8">Cancelled</td> : null}
                                    {item.order_status === 'PICKUP_READY' ? <td className="badge badge-pill badge-info d-block mg-t-8">Ready</td> : null}
                                    {item.order_status === 'TAKEOUT' ? <td className="badge badge-pill badge-success d-block mg-t-8">Delivered</td> : null}
                                    {item.order_status === 'Pending Payment' ? <td className="badge badge-pill badge-secondary d-block mg-t-8">Pending Payment</td> : null}
                                    {item.order_status !== 'ORDER_AHEAD' && item.order_status !== 'Processing' && item.order_status !== 'PICKUP_READY' && item.order_status !== 'TAKEOUT' && item.order_status !== 'Complete' && item.order_status !== 'Confirmed' && item.order_status && item.order_status !== 'Cancelled' && item.order_status !== 'Pending Payment' ? <td className="badge badge-pill badge-info d-block mg-t-8">{item.order_status}</td> : null}
                                    <td>{item.billing_details.first_name} {item.billing_details.last_name}</td>
                                    <td>{item.billing_details.email}</td>
                                    <td>{item.order_date}</td>
                                    <td className="hidden">
                                      <div className="dropdown">
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                          <span className="flaticon-more-button-of-three-dots" />
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right" style={{display:'none'}}>
                                          <a className="dropdown-item" href="#"><i className="fas fa-times text-orange-red" />Close</a>
                                          <a className="dropdown-item" href="#"><i className="fas fa-cogs text-dark-pastel-green" />Edit</a>
                                          <a className="dropdown-item" href="#"><i className="fas fa-redo-alt text-orange-peel" />Refresh</a>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {(item.order_status === 'Processing' || item.order_status === 'ORDER_AHEAD') && <>
                                        <a className="btn btn-success btn-lg" style={{'color':'#ffffff'}} onClick={(e) =>openTimingModal(item.order_id, 'confirm', tabValue)}><i className="fas fa-check" aria-hidden="true"> Accept</i></a>
                                        <a style={{'margin-left': '10px', 'color': '#ffffff'}} className="btn btn-danger btn-lg" onClick={(e) =>handleacceptOrder(item.order_id, 'cancel', tabValue)}><i className="fas fa-times" aria-hidden="true"> Decline</i></a>
                                      </>}
                                      {item.order_status === 'Confirmed' && <>
                                        <a className="btn btn-success btn-lg" style={{'color':'#ffffff'}} onClick={(e) =>handleacceptOrder(item.order_id, 'ready_for_pickup', tabValue)}><i className="fas fa-hard-hat" aria-hidden="true"> Ready for Pickup</i></a>
                                      </>}
                                      {item.order_status === 'PICKUP_READY' && <>
                                        <a className="btn btn-success btn-lg" style={{'color':'#ffffff'}} onClick={(e) =>handleacceptOrder(item.order_id, 'picked_up', tabValue)}><i className="fas fa-walking" aria-hidden="true"> Picked Up</i></a>
                                      </>}
                                      {item.order_status === 'TAKEOUT' && <>
                                        <a className="btn btn-success btn-lg" style={{'color':'#ffffff'}} onClick={(e) =>handleacceptOrder(item.order_id, 'delivered', tabValue)}><i className="fas fa-truck" aria-hidden="true"> Delivered</i></a>
                                      </>}
                                    </td>
                                  </tr>
                                )
                              })}


                              </tbody>
                            </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                
              </div>

            </div>
          </div>
        </div>



      </div>
      {/* Dashboard Content End Here */}

      </div>
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-darkblue"  style={{display:"flex", justifyContent:"center"}}>
        <h5 class="modal-title text-light" id="exampleModalLabel">SCHEDULE THE ORDER</h5>
        
      </div>
      <div class="modal-body">
        <h6 className='text-center'>Order will be ready for pickup within following minutes:</h6>
     <hr/>
     <form>
      <div className="col-lg-12 col-12 form-group">
      {ordertimeElements}
                      </div>
  </form>
      </div>
      <div class="modal-footer">
      <button type="submit" className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float mg-l-10" onClick={(e) =>handleacceptOrder(orderId, 'confirm', 2)}>Save</button>
      <button type="reset" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark right-float" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
      </>
        );
}

export default Orders;